import "url-search-params-polyfill";


  console.log("Hello from google analytics");
  document.addEventListener("turbolinks:load", function() {
    if (getParameterByName("hidden") !== "true") {
      gtag("config", "UA-45690715-8");
    }
  });

  function getParameterByName(name) {
    return new URLSearchParams(window.location.search).get(name);
  }

